import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";

import { DEV_AUTH_ENABLED } from "~/constants/mockUserData";
import { useSession } from "~/providers/SessionProvider";

const noAuthPaths = [
  "/login",
  "/tenant/login",
  "/landlord/login",
  "/tenant/create-account",
  "/landlord/create-account",
  "/forgot-password",
];

const AuthRedirection = () => {
  const navigate = useNavigate();
  const pathname = useLocation().pathname;

  const { isAuthenticated, user, isLoading } = useSession();

  useEffect(() => {
    // Skip all auth redirects in dev bypass mode
    if (DEV_AUTH_ENABLED) {
      return;
    }

    if (!isLoading) {
      if (isAuthenticated) {
        // If the user is currently authenticated and on
        // a noAuthPaths, redirect to their role home.
        if (noAuthPaths.includes(pathname)) {
          const role = user?.internalRole;
          navigate(`/${role}`, { replace: true });
          return;
        }

        const role = user?.internalRole;

        // If the user is currently authenticated and on
        // the wrong role page, redirect to their role home.
        if (role === "landlord") {
          if (pathname.startsWith("/tenant")) {
            navigate("/landlord", { replace: true });
            return;
          }
        }

        if (role === "tenant") {
          if (pathname.startsWith("/landlord")) {
            navigate("/tenant", { replace: true });
            return;
          }
        }
      }

      // If the user is not authenticated and on a /tenant or /landlord url, that is not a noAuthPath,
      // redirect to the login page.
      if (!isAuthenticated) {
        if (
          pathname.startsWith("/tenant") ||
          pathname.startsWith("/landlord")
        ) {
          const findPathStartingWith = noAuthPaths.findIndex((path) =>
            pathname.startsWith(path)
          );

          if (findPathStartingWith === -1) {
            navigate("/login", { replace: true });
            return;
          }
        }
      }
    }
  }, [isLoading, isAuthenticated, pathname, navigate, user]);

  return null;
};

export default AuthRedirection;
